<template>
  <transition name="slide-up">
    <div v-if="visible"
         class="cookie-notice">
      <p class="cookie-text">
        Мы используем cookie для улучшения работы сайта. Подробнее — в нашей
        <a href="/privacy-policy"
           target="_blank"
           class="link">Политике обработки персональных данных</a>.
      </p>
      <div class="cookie-actions">
        <button class="cookie-secondary"
                @click="goToCookies">Подробнее о cookie
        </button>
        <button class="cookie-primary"
                @click="acceptCookies">Принять
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieNotice',
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    if (!localStorage.getItem('cookiesAccepted')) {
      this.visible = true
    }
  },
  methods: {
    acceptCookies () {
      localStorage.setItem('cookiesAccepted', 'true')
      this.visible = false
    },
    goToCookies () {
      this.$router.push('/cookie-policy')
    }
  }
}
</script>

<style scoped>
  .cookie-notice {
    position: fixed;
    top: 24px;
    right: 24px;
    max-width: 400px;
    background-color: #fff;
    color: #000;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    font-size: 15px;
    border-radius: 12px;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .cookie-text {
    margin: 0;
  }
  .link {
    color: #007bff;
    text-decoration: underline;
  }
  .cookie-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-wrap: wrap;
  }
  .cookie-primary {
    padding: 10px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
  }
  .cookie-secondary {
    padding: 10px 16px;
    background-color: transparent;
    border: 1px solid #007bff;
    color: #007bff;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
  }
  /* 👉 Мобильная версия — попап снизу */
  @media (max-width: 768px) {
    .cookie-notice {
      top: auto;
      bottom: 0;
      left: 0;
      right: 0;
      max-width: none;
      border-radius: 12px 12px 0 0;
      padding: 20px 16px 32px;
      box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.25);
      animation: slideUp 0.3s ease-out;
    }
    .cookie-actions {
      flex-direction: column;
      align-items: stretch;
    }
    .cookie-primary,
    .cookie-secondary {
      width: 100%;
      text-align: center;
    }
  }
  /* Slide-up transition */
  .slide-up-enter-active {
    animation: slideUp 0.3s ease-out forwards;
  }
  .slide-up-leave-active {
    animation: slideDown 0.2s ease-in forwards;
  }
  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0%);
      opacity: 1;
    }
  }
  @keyframes slideDown {
    from {
      transform: translateY(0%);
      opacity: 1;
    }
    to {
      transform: translateY(100%);
      opacity: 0;
    }
  }
</style>
